import React from "react"
import Select from "react-select"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import selectMenuStyles from "src/pages/dynamic_forms/Utils/SelectMenuStyles"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./DropDownField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean

}

function DropDownField(props: Props) {

    // console.log("df_FieldDropDownField props", props)

    const field = props.field
    const options = field.CustomValues || []
    const value = !props.formManagerField ? field.Value : null
    const name = field.Name || "Select"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"
    const menuPosition = fieldType === "Field" ? "fixed" : "absolute"

    return (
        <div className={`DynamicForm${fieldType} DynamicFormDropdown${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <Select
                    placeholder={props.field.Label}
                    //@ts-ignore
                    value={{ label: value }}
                    //@ts-ignore
                    options={options.map((item) => ({ value: item, label: item }))}
                    onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])}
                    onChange={(item: any) => {
                        const fieldValue = item ? item.value : null //handling clearable input
                        if (fieldValue) {
                            props.handleChange({ target: { value: fieldValue } })
                        } else {
                            props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
                            props.handleChange({ target: { value: fieldValue } })
                        }

                    }}
                    menuPosition={menuPosition}
                    styles={selectMenuStyles}
                    isClearable={value ? true : false}
                />
            </div>
        </div>
    )
}

export default DropDownField